import { CustomNode } from '../../../types';
import { addContactIcon } from '../../../icons';

const DEFAULT_ICON = addContactIcon;

export const addContactConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
